import * as types from './types'
import { toast } from 'react-toastify'
import history from 'history.js'
import HttpHandler from 'app/reusable/HttpHandler'
import * as Sentry from '@sentry/react'
import Firebase from 'Firebase'
import Analytics, { ANALYTICS_EVENT } from 'app/reusable/Analytics'
import { fetchFeatureFlags } from 'app/ducks/featureFlags/actions'

export const login =
  (
    username,
    password,
    totpCode,
    persist,
    successCallback = null,
    errorCallback = null
  ) =>
  (dispatch) => {
    return toast
      .promise(HttpHandler.authenticate(username, password, totpCode), {
        pending: 'Realizando login...',
        success: 'Login realizado com sucesso.',
        error: 'Algo deu errado, verifique seu usuário e senha.',
      })
      .then(({ data: { token } }) => {
        dispatch({
          type: persist ? types.LOGIN_PERSIST : types.LOGIN,
          payload: token,
        })
        Firebase.logEvent(ANALYTICS_EVENT.LOGIN)
        dispatch(getUserInfo(token, successCallback, errorCallback))
      })
      .catch(() => {
        errorCallback && errorCallback()
      })
  }

export const getUserInfo =
  (token, successCallback = null, errorCallback = null) =>
  (dispatch) =>
    HttpHandler.getUserInfo(token)
      .then(
        ({
          data: {
            user_info,
            permissions,
            access_types,
            has_password,
            feature_flags,
          },
        }) => {
          try {
            Sentry.setUser({
              ...user_info,
              access_types,
            })
            Firebase.setUser(user_info)
          } catch (e) {
            Sentry.captureException(e)
            console.warn('Unable to track user', e)
          }
          dispatch({
            type: types.USER_INFO,
            payload: {
              token,
              userInfo: user_info,
              has_password,
              permissions,
              access_types,
              featureFlags: feature_flags,
            },
          })

          // Fire-and-forget: a successful login must never be blocked or
          // undone by the feature-flags fetch failing (see
          // ducks/featureFlags/actions.js#fetchFeatureFlags — a failure
          // there just leaves any previously-cached flags in place), so
          // this isn't awaited/chained into the login promise.
          dispatch(fetchFeatureFlags(user_info?.id))

          successCallback && successCallback(token)
        }
      )
      .catch(() => {
        errorCallback && errorCallback()
      })

export const logout = () => (dispatch) => {
  Firebase.logEvent(ANALYTICS_EVENT.LOGOUT)
  // Flushed while the session token is still available, so the event is authenticated
  Analytics.flush()
  dispatch({ type: types.LOGOUT })
  history.replace('/session/signin')
}
